/**
* Copyright Aquera Inc 2023
*
* This source code is licensed under the BSD-3-Clause license found in the
* LICENSE file in the root directory of this source tree.
*/

import {css} from 'lit';

/**
 * Detail CSS
 */
export const styles = css`

  :host {
    box-sizing: border-box;
    -webkit-font-smoothing: var(--nile-webkit-font-smoothing, var(--ng-webkit-font-smoothing));
    -moz-osx-font-smoothing: var(--nile-moz-osx-font-smoothing, var(--ng-moz-osx-font-smoothing));
    text-rendering: var(--nile-text-rendering, var(--ng-text-rendering));
  }

  :host *,
  :host *::before,
  :host *::after {
    box-sizing: inherit;
  }

  [hidden] {
    display: none !important;
  }

  :host {
    display: block;
  }

  .accordian {
    border-top:solid 1px var(--nile-colors-neutral-500 , var(--ng-colors-border-primary));
    background-color: var(--nile-colors-white-base , var(--ng-colors-bg-primary));
    overflow-anchor: none;
    line-height: var(--nile-line-height-inherit , var(--ng-line-height-text-sm));
  }

  .accordian--lg{
    --accordian-text-size:var(--nile-type-scale-3 , var(--ng-font-size-text-sm));
    --accordian-heading-padding: var(--nile-spacing-xl , var(--ng-spacing-xl)) var(--nile-spacing-lg , var(--ng-spacing-lg));
    --accordian-content-padding: var(--nile-spacing-sm , var(--ng-spacing-sm)) var(--nile-spacing-lg , var(--ng-spacing-lg)) var(--nile-spacing-xl , var(--ng-spacing-3xl));
    --accordion-font-family : var(--nile-font-family-sans-serif, var(--ng-font-family-body));
  }

  .accordian--md{
    --accordian-text-size:var(--nile-type-scale-3 , var(--ng-font-size-text-sm));
    --accordian-heading-padding: var(--nile-spacing-lg , var(--ng-spacing-lg)) var(--nile-spacing-lg , var(--ng-spacing-lg));
    --accordian-content-padding: var(--nile-spacing-sm , var(--ng-spacing-sm)) var(--nile-spacing-lg , var(--ng-spacing-lg)) var(--nile-type-scale-5 , var(--ng-spacing-3xl));
    --accordion-font-family: var(--nile-font-family-sans-serif, var(--ng-font-family-body));
  }

  .accordian--sm{
    --accordian-text-size:var(--nile-type-scale-3 , var(--ng-font-size-text-sm));
    --accordian-heading-padding: var(--nile-spacing-sm , var(--ng-spacing-sm)) var(--nile-spacing-lg , var(--ng-spacing-lg));
    --accordian-content-padding: var(--nile-spacing-sm , var(--ng-spacing-sm)) var(--nile-spacing-lg , var(--ng-spacing-xl)) var(--nile-spacing-lg , var(--ng-spacing-lg));
    --accordion-font-family: var(--nile-font-family-sans-serif, var(--ng-font-family-body));
  }
  
  .accordian {
    font-size: var(--accordian-text-size);
    font-family: var(--accordion-font-family)
  }

  .accordian--disabled {
    opacity: 0.5;
  }

  .accordian__header {
    display: flex;
    gap:var(--nile-spacing-lg , var(--ng-spacing-lg));
    align-items: center;
    border-radius: inherit;
    font-weight: var(--nile-font-weight-medium , var(--ng-font-weight-semibold));
    padding: var(--accordian-heading-padding);
    user-select: none;
    cursor: pointer;
  }

  .accordian__header--dark{
    background-color:var(--nile-colors-dark-200 , var(--ng-colors-bg-tertiary));
  }

  .accordian__header--arrow-left{
    flex-direction: row-reverse;
  }

  .accordian__header:focus {
    outline: none;
  }

  .accordian__header:focus-visible {
    outline: solid 3px var(--nile-colors-blue-500);
    box-shadow: var(--nile-box-shadow-none, var(--ng-focus-ring-shadow-xs));
    outline-offset: calc(1px + 1px);
  }

  .accordian--disabled .accordian__header {
    cursor: not-allowed;
  }

  .accordian--disabled .accordian__header:focus-visible {
    outline: none;
    box-shadow: none;
  }

  .accordian__summary {
    flex: 1 1 auto;
    display: flex;
    align-items: center;
  }

  .accordian__summary-icon {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    transition: 250ms rotate ease;
  }

  .accordian--open .accordian__summary-icon {
    rotate: 90deg;
  }

  .accordian--open slot[name='expand-icon'],
  .accordian:not(.accordian--open) slot[name='collapse-icon'] {
    display: none;
  }

  .accordian__body {
    overflow: hidden;
  }

  .accordian__content {
    display: block;
    padding: var(--accordian-content-padding);
  }

  .accordian__content--arrow-left{
   margin-left: var(--nile-spacing-4-x , var(--ng-spacing-3xl-alt));  
  }
`;

export default [styles];
